
jQuery(document).ready(function () {
	wowo(jQuery);
	home();
	menu();
	pdp();
	faqs();
	swiper_items();
	video();
	numbers();
	resize_block();
	range_slider();

});

jQuery(window).scroll(function () {
	wowo(jQuery);
	numbers();
});

jQuery(window).resize(function () {
	resize_block();
});




function wowo($) {
	setTimeout(function () {
		jQuery('html').addClass("show-c");

		var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
		jQuery(".wowo:not(.animated)").each(function () {
			var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
				limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
			if (meTop > limitTop && meBottom < limitBottom) {
				me.addClass("animated");
				setTimeout(function () {
					me.removeClass("animated wowo");
				}, 1500);
			}
		})
	}, 100);

}

function menu() {

	jQuery('.hamburger').click(function () {
		jQuery("html").css("overflow", "hidden");
		jQuery("header .header__top .header__top__box .header__menu").addClass('is-open');
		jQuery(".language-toggle-bar").css("z-index", "2");
		jQuery(".menu-mask").fadeIn(300);
	});
	jQuery('header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .header__menu__logo__colse .close__menu').click(function (e) {
		e.preventDefault();
		jQuery("header .header__top .header__top__box .header__menu").removeClass('is-open');
		jQuery(".language-toggle-bar").css("z-index", "3");
		jQuery(".menu-mask").fadeOut(300);
		jQuery("html").css("overflow", "inherit");
	});
	// Clear the selected items on background click
	jQuery(document).on("click", function (event) {
		var $nav = jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow");
		if (!$nav.is(event.target) && $nav.has(event.target).length === 0) {
			jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .menu-item-has-children .sub-menu-content.is-open").removeClass("is-open");
			jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back .sub-back").empty();
			jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .sub-menu-content__box>ul>li.menu-item-has-children .sub-menu-content__box__box.is-open").removeClass("is-open");
			jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .sub-menu-content__box>ul>li.menu-item-has-children .sub-menu-content__box__box__box.is-open").removeClass("is-open");
			jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back").children(".sub-back").remove();
		}
	});
	
	

	jQuery("li.menu-item-has-children > a").click(function (e) {
		var link = jQuery(this);
		var href = link.attr("href");
		var text_c = link.text();

		// Check if the click occurred on the :before pseudo-element
		var clickedElement = e.target;
		var isBeforeElement = window.getComputedStyle(clickedElement, ":before").content !== "none";

		if (!href || href.includes("javascript:void(0)") || isBeforeElement) {

			e.preventDefault();
			e.stopPropagation();

			// Toggle active class and sub-menu visibility
			link.toggleClass("is-active");
			link.siblings(".sub-menu-content").toggleClass("is-open");

			// Handle overflow and menu mask display
			if (link.hasClass("is-active")) {
				jQuery("html").css("overflow", "unset");
				if (!link.parents("li").hasClass("active--style")) {
					jQuery(".menu-mask").fadeIn(300);
				}
			} else {
				// Remove menu mask when clicked again
				jQuery(".menu-mask").fadeOut(300);
				jQuery("html").css("overflow", "unset");
			}

			// Remove active classes and close siblings' sub-menus
			link.parents(".menu-item-has-children").siblings().children("a").removeClass("is-active");
			link.parents(".menu-item-has-children").siblings().children(".sub-menu-content").removeClass("is-open");

			// Additional functionality for links without href
			if (href === "javascript:void(0)" || isBeforeElement) {
				var subMenuBox = link.siblings(".sub-menu-content__box__box");

				// Check the next sibling for the desired classes instead of using closest
				if (!subMenuBox.length) {
					var nextSibling = link.next();
					if (nextSibling.hasClass("sub-menu-content__box__box") ||
						nextSibling.hasClass("sub-menu-content__box__box__box")) {
						subMenuBox = nextSibling;
					}
				}

				if (subMenuBox.length > 0) {
					subMenuBox.addClass("is-open");
					
					// Add the collection name to the data attribute
					subMenuBox.attr("data-collection-name", text_c); // Set the clicked collection name
				}

				// Use closest to find the relevant back button for breadcrumb updates
				var backElement = link.closest(".sub-menu-content").find(".back");
				if (backElement.length > 0) {
					var subBackClassIndex = backElement.find('.sub-back').length + 1; // Determine the next index
					backElement.append(
						`<span class='sub-back sub-back-${subBackClassIndex}'><span>/</span><span class='sub-back-link'>${text_c}</span></span>`
					);
					backElement.addClass("sub-link");
				}
			}
		}
	});

// Breadcrumb(.sub-back-link) navigation clicks in the submenu
	jQuery("body").on("click", "header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back .sub-back-link", function (e) {
		e.preventDefault();

		var $clickedLink = jQuery(this);
		var linkText = $clickedLink.text().trim();
		var $parentBack = $clickedLink.closest(".sub-back");

		var matchedBox = null;

		jQuery(".sub-menu-content__box__box").each(function () {
			var $box = jQuery(this);
			var collectionName = $box.data("collection-name");

			if (collectionName && collectionName.trim() === linkText) {
				matchedBox = $box;
				return false;
			}
		});

		if ($parentBack.hasClass("sub-back-1")) {
			jQuery(".sub-menu-content__box__box.is-open").not(matchedBox).removeClass("is-open").css("overflow", "unset");
			jQuery(".sub-menu-content__box__box__box.is-open").removeClass("is-open").css("overflow", "unset");
		}

		if ($parentBack.hasClass("sub-back-2")) {
			jQuery(".sub-menu-content__box__box__box.is-open").removeClass("is-open").css("overflow", "unset");
		}

		if (matchedBox) {
			matchedBox.addClass("is-open");
		}
		$parentBack.nextAll(".sub-back").remove();
	});

	jQuery("body").on("click", "header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back .first--back", function (e) {
		e.preventDefault();
		var text_c = jQuery(this).text();
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .sub-menu-content__box .sub-menu-content__box__box").each(function () {
			jQuery(this).removeClass("is-open");
		});
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .sub-menu-content__box>ul>li.menu-item-has-children> .sub-menu-content__box__box ul li.menu-item-has-children>a").siblings(".sub-menu-content__box__box__box").removeClass("is-open");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back .sub-back").empty();
		jQuery(this).siblings(".sub-back").remove();
	});

	jQuery("body").on("mouseenter", "header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box ul li", function() {
		var $menuItem = jQuery(this);
		var $submenu = $menuItem.find('.sub-menu-content__box__box').first();

		if ($submenu.length) {
			var menuItemOffset = $menuItem.offset();
			var submenuWidth = $submenu.outerWidth();
			var windowWidth = jQuery(window).width();
			var spaceOnRight = windowWidth - (menuItemOffset.left + $menuItem.outerWidth());
			if (spaceOnRight < (submenuWidth)) {
				$submenu.addClass('open-left');
			} else {
				$submenu.removeClass('open-left');
			}
		}
	});


	jQuery(".menu-mask").click(function (e) {
		e.preventDefault();
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children a").removeClass("is-active");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content").removeClass("is-open");
		jQuery(".menu-mask").fadeOut(300);
		jQuery("header .header__top .header__top__box .header__menu").removeClass('is-open');
		jQuery("html").css("overflow", "inherit");
	});

	jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li .sub-menu-content .back .back--all").click(function (e) {
		e.preventDefault();
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children a").removeClass("is-active");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content").removeClass("is-open");
		if (jQuery(window).width() > 768) {
			jQuery(".menu-mask").fadeOut(300);
		}
		jQuery("html").css("overflow", "inherit");
	});

	jQuery("body").click(function (e) {
		jQuery("html").css("overflow", "inherit");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.active--style .sub-menu-content").removeClass("is-open");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.active--style a").removeClass("is-active");
	});
	jQuery("body .header .header__top .header__top__box .header__links>div.icon-user .icon").click(function (e) {
		e.preventDefault();

	});
	jQuery(".quick-order-btn").click(function (e) {
		e.preventDefault();
		jQuery("html").css("overflow", "hidden");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children a").removeClass("is-active");
		jQuery("header .header__top .header__top__box .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content").removeClass("is-open");
		if (jQuery(window).width() < 768) {
			jQuery("header .header__top .header__top__box .header__menu").removeClass('is-open');
		}
		jQuery(".quick-order-modal").addClass("is-show");
		jQuery(".menu-mask").fadeOut(300);


	});

	const resetQuickOrderModal = function (e) {
		if (e) {
			e.stopPropagation();
		}

		jQuery("html").css("overflow", "inherit");
		jQuery(".quick-order-modal").removeClass("is-show");
		jQuery(".quick-order-modal__boxed__content__items").empty();
		jQuery('.quick-order-modal__boxed__no-results').removeClass('is-show');
		jQuery('.total-items').text('0');
		jQuery('.subtotal').text('$0.00');
	};

	jQuery(".quick-order-modal").click(resetQuickOrderModal);
	jQuery(".quick-order-modal__boxed__title .close-modal").click(resetQuickOrderModal);

	jQuery(".quick-order-modal__boxed").click(function (e) {
		e.stopPropagation();
	});

	jQuery(document).keyup(function (event) {
		const modalActive = jQuery(".quick-order-modal").hasClass("is-show");

		if (event.key === "Escape" && modalActive) {
			resetQuickOrderModal()
		}
	});

	jQuery(".quick-order-modal").click(resetQuickOrderModal);
	jQuery(".quick-order-modal__boxed__title .close-modal").click(resetQuickOrderModal);

	jQuery(".quick-order-modal__boxed").click(function (e) {
		e.stopPropagation();
	});

	jQuery(document).keyup(function (event) {
		const modalActive = jQuery(".quick-order-modal").hasClass("is-show");

		if (event.key === "Escape" && modalActive) {
			resetQuickOrderModal()
		}
	});
}






function home() {


	if (jQuery(window).width() <= 992) {
		jQuery("footer .footer__main .footer__main__menu .menu>li span").click(function () {
			jQuery(this).toggleClass("active");
			jQuery(this).siblings("ul").slideToggle(300);
			jQuery(this).parents("li").siblings().find("span").removeClass("active");
			jQuery(this).parents("li").siblings().find("ul").slideUp(300);
		});
	}
	jQuery(".boxed-column__item__block .btn").hover(function () {
		jQuery(this).parents(".boxed-column__item__block").toggleClass("active");
	});
	if (jQuery(window).width() <= 992) {
		jQuery(".icp-categories-listing__item__content__filter__categories__button>a").click(function (e) {
			e.preventDefault();
			jQuery(this).toggleClass("active");
			jQuery(this).siblings("ul").slideToggle(300);

		});
		jQuery(".icp-listing__item__content__filter__categories__button>a").click(function (e) {
			e.preventDefault();
			jQuery(this).toggleClass("active");
			jQuery(this).siblings("ul").slideToggle(300);

		});

		jQuery(".plp-listing__item__content__filter__button.tablet>a").click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").attr("open", "'true");
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").addClass("menu-opening");
			jQuery("header").css("z-index", "0");
			jQuery("html").css("overflow", "hidden");

		});
		jQuery("section div .facets-container .mobile-facets .mobile-facets__inner .mobile-facets__header .mobile-facets__count").click(function (e) {
			e.stopPropagation();
			e.preventDefault();
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").attr("open", false);
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").removeClass("menu-opening");
			jQuery("header").css("z-index", "99999");
			jQuery("html").css("overflow", "inherit");

		});

		jQuery("section div .facets-container .mobile-facets .mobile-facets__inner .filter-mobile-btn").click(function (e) {
			e.stopPropagation();
			e.preventDefault();
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").attr("open", false);
			jQuery(".mobile-facets__disclosure.disclosure-has-popup").removeClass("menu-opening");
			jQuery("header").css("z-index", "99999");
			jQuery("html").css("overflow", "inherit");

		});

	}
	jQuery(".anchor--product--descriptio").click(function (e) {
		e.preventDefault();
		var block = jQuery(".pdp-details__item__left__product__description");
		var he = jQuery("header").height();
		jQuery('html,body').stop().animate({ scrollTop: block.offset().top - he }, 600);

	});



	jQuery('.resources-listing-filter form input').on('input', function (event) {
		var searchTerm = jQuery(this).val();
		if (searchTerm != "") {
			jQuery(".resources-listing__top__search .reset__button").addClass("is-show");
		} else {
			jQuery(".resources-listing__top__search .reset__button").removeClass("is-show");
		}
	});
	jQuery('.resources-listing-filter form').on('submit', function (event) {
		event.preventDefault();
		var foundAnyMatch = false;
		var searchTerm = jQuery(this).find("input").val().toLowerCase();
		if (searchTerm != "") {
			jQuery('.resources-listing:not(.resources-listing-filter)').each(function () {
				var items = jQuery(this).find('.resources-listing__items__block__content__box__card').find("h3");
				var hasMatch = false;

				items.each(function () {
					if (jQuery(this).text().toLowerCase().indexOf(searchTerm) !== -1) {
						jQuery(this).parents(".resources-listing__items__block__content__box__card").fadeIn(200);
						hasMatch = true;
						foundAnyMatch = true;

					} else {
						jQuery(this).parents(".resources-listing__items__block__content__box__card").fadeOut(200);

					}
				});


				if (hasMatch) {
					jQuery(this).fadeIn(200);
				} else {
					jQuery(this).fadeOut(200);
				}
			});

			if (foundAnyMatch == false) {
				jQuery(".resources-listing-filter .container").append("<div class='status'><p>No matches found. Please refine your search or contact support for help.</p></div>");
			} else {
				jQuery(".resources-listing-filter .container .status").remove();
			}
		} else {
			jQuery('.resources-listing:not(.resources-listing-filter)').fadeIn(200);
			jQuery('.resources-listing:not(.resources-listing-filter) .resources-listing__items__block__content__box__card').fadeIn(200);
		}

	});
	jQuery('.resources-listing-filter .reset__button svg').click(function (event) {
		event.preventDefault();

		jQuery(".resources-listing__top__search input").val("");
		jQuery('.resources-listing:not(.resources-listing-filter)').fadeIn(200);
		jQuery('.resources-listing:not(.resources-listing-filter) .resources-listing__items__block__content__box__card').fadeIn(200);
		jQuery(".resources-listing__top__search .reset__button").removeClass("is-show");
		jQuery(".resources-listing-filter .container .status").remove();

	});



}


function pdp() {
	jQuery('.text-read-more').each(function () {
		var this_c = jQuery(this);

		if (this_c.find('p').length > 1) {
			var firstParagraph = this_c.find('p').first().prop('outerHTML');
			var remainingParagraphs = this_c
				.find('p')
				.not(':first')
				.map(function () {
					return $(this).prop('outerHTML');
				})
				.get()
				.join('');
			this_c
				.children('.text-read-more__show')
				.append("<div class='text__first'>" + firstParagraph + '</div>');
			if (remainingParagraphs != '') {
				this_c
					.children('.text-read-more__show')
					.append("<div class='text__last'>" + remainingParagraphs + '</div>');
				this_c
					.children('.text-read-more__show')
					.append("<a href='#' class='link-border read-more'>Read More</a>");
			}
		} else {
			var firstParagraph = this_c.find('p').first().prop('outerHTML');
			this_c.children('.text-read-more__show').append("<div class='text__first'>" + firstParagraph + '</div>');
		}
	});
	jQuery('body').on('click', '.text-read-more__show .read-more', function (event) {
		event.preventDefault();
		var this_c = jQuery(this);
		jQuery(this).toggleClass('is-active');
		jQuery(this).siblings('.text__last').slideToggle(300);
		if (jQuery(this).hasClass('is-active')) {
			this_c.text('Less');
		} else {
			this_c.text('Read More');
		}
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'collection_description_expand',
			'collection_description': jQuery('.text-read-more__show .text__first p').text()
		});
	});



	jQuery("body").on("mousemove", ".product-item a", function () {
		jQuery(this).parents(".product-item").addClass("hover");
	});

	jQuery("body").on("mouseout", ".product-item a", function () {
		jQuery(this).parents(".product-item").removeClass("hover");
	});
}

function faqs() {
	jQuery(".faqs__box__items__block .faqs__box__items__block__title").click(function () {
		jQuery(this).toggleClass("active");
		jQuery(this).siblings(".faqs__box__items__block__text").slideToggle(300);
		jQuery(this).parents(".faqs__box__items__block").siblings().find(".faqs__box__items__block__title").removeClass("active");
		jQuery(this).parents(".faqs__box__items__block").siblings().find(".faqs__box__items__block__text").slideUp(300);
	});

	jQuery(".resources-listing .resources-listing__items__block .resources-listing__items__block__title").click(function () {
		jQuery(this).toggleClass("active");
		jQuery(this).siblings(".resources-listing__items__block__content").slideToggle(300);
		//		jQuery(this).parents(".resources-listing__items__block ").siblings().find(".resources-listing__items__block__title").removeClass("active");
		//		jQuery(this).parents(".resources-listing__items__block ").siblings().find(".resources-listing__items__block__content").slideUp(300);
	});

}

function swiper_items() {


	if (jQuery(".recommended-links__swiper").length > 0) {
		var Swiper1 = new Swiper(".recommended-links__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.recommended-links__swiper .swiper-button-next',
				prevEl: '.recommended-links__swiper .swiper-button-prev',
			},
		});
	}

	if (jQuery(".hero-banner__swiper .swiper-slide").length > 1) {
		var Swiper2 = new Swiper(".hero-banner__swiper", {
			loop: true,
			effect: "fade",

			autoplay: {
				delay: 7500,
				stopOnLastSlide: false,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.hero-banner__swiper .swiper-pagination',

				clickable: true,
			},
		});

		jQuery('.hero-banner__swiper .swiper-pagination').append("<i class='pause--icon'></i>");

		jQuery("body").on("click", ".hero-banner__item .hero-banner__swiper .swiper-pagination .pause--icon", function (e) {
			jQuery(this).toggleClass("is-play");
			if (jQuery(this).hasClass("is-play")) {
				Swiper2.autoplay.stop();
			} else {
				Swiper2.autoplay.start();
			}
		});
	} else {
		jQuery(".hero-banner__item .hero-banner__swiper .swiper-pagination").addClass("is-hide");
	}

	if (jQuery(".best-categories__swiper").length > 0) {
		var Swiper3 = new Swiper(".best-categories__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.best-categories__swiper .swiper-button-next',
				prevEl: '.best-categories__swiper .swiper-button-prev',
			},
		});
	}

	if (jQuery(".industry__swiper").length > 0) {
		var Swiper4 = new Swiper(".industry__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.industry__swiper .swiper-button-next',
				prevEl: '.industry__swiper .swiper-button-prev',
			},
		});
	}

	if (jQuery(".news__swiper").length > 0) {
		var Swiper5 = new Swiper(".news__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.news__swiper .swiper-button-next',
				prevEl: '.news__swiper .swiper-button-prev',
			},
		});
	}

	if (jQuery(".customers-also-bought__swiper").length > 0) {
		var Swiper6 = new Swiper(".customers-also-bought__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.customers-also-bought__swiper .swiper-button-next',
				prevEl: '.customers-also-bought__swiper .swiper-button-prev',
			},
		});
	}

	if (jQuery(".essentials__swiper").length > 0) {
		if (jQuery(window).width() <= 768) {
			var Swiper7 = new Swiper(".essentials__swiper", {
				speed: 800,
				slidesPerView: "auto",
				resistance: true,
				navigation: {
					nextEl: '.essentials__swiper .swiper-button-next',
					prevEl: '.essentials__swiper .swiper-button-prev',
				},
			});
		}
	}


	if (jQuery(".pdp-details__item__left__box__product__image__top__gallery").length > 0) {




		var swiper7 = new Swiper(".pdp-details__item__left__box__product__image__thumbs__gallery", {
			loop: false,
			freeMode: true,
			watchSlidesProgress: true,
			slidesPerView: "auto",
			resistance: true,
			//autoplay:true,

		});
		var swiper8 = new Swiper(".pdp-details__item__left__box__product__image__top__gallery", {
			loop: true,
			spaceBetween: 4,
			pagination: {
				el: ".pdp-details__item__left__box__product__image__top__gallery .swiper-pagination",
				type: "fraction",
			},
			navigation: {
				nextEl: ".pdp-details__item__left__box__product__image__top__gallery .swiper-button-next",
				prevEl: ".pdp-details__item__left__box__product__image__top__gallery .swiper-button-prev",
			},
			thumbs: {
				swiper: swiper7,
			},
			breakpoints: {
				768: {
					spaceBetween: 0,
				},

			},
		});

		if (jQuery(".myPanzoom").length > 0) {
			const container = document.getElementById("myPanzoom");
			const options = { click: "toggleCover" };

			new Panzoom(container, options);
		}
		jQuery("body").on("click", ".pdp-details__item__left__box__product__image__top__gallery .swiper-slide .panzoom__box .fullsize", function () {
			var src = jQuery(this).parents(".myPanzoom").find("img").attr("src");
			var src2 = jQuery(this).parents(".myPanzoom").find(".image-view").attr("src");
			var view_link = jQuery(this).parents(".myPanzoom").find(".view-link").html();


			jQuery(".media-pop-up__item__box .media-pop-up__item__box__img").append("<img src='" + src + "' />");
			jQuery(".media-pop-up__item__box .media-pop-up__item__box__view").append("<img src='" + src2 + "' />");
			jQuery(".media-pop-up__item__box .media-pop-up__item__box__view__link").append(view_link);
			jQuery(".media-pop-up__item__box .media-pop-up__item__box__view__link a").addClass("show");
			jQuery('.media-pop-up').fadeIn(300);
		});


		jQuery('.media-pop-up .media-pop-up__item__close').click(function () {
			jQuery(document).unbind('mousewheel DOMMouseScroll');
			jQuery(document).unbind('touchmove');

			if (jQuery(".media-pop-up__item__box .media-pop-up__item__box__view").hasClass("show")) {
				jQuery(".media-pop-up__item__box .media-pop-up__item__box__view").removeClass("show");
			} else {
				jQuery('.media-pop-up').fadeOut(300);
				setTimeout(function () {
					jQuery('.media-pop-up').find('.media-pop-up__item__box__video').html('');
					jQuery('.media-pop-up').find('.media-pop-up__item__box__img').html('');
					jQuery('.media-pop-up').find('.media-pop-up__item__box__view__link').html('');
					jQuery(".media-pop-up .media-pop-up__item__box__video").removeClass("hide-paly-icon");


				}, 300);
			}
		});



		jQuery("body").on("click", ".media-pop-up__item__box .view", function (e) {
			e.preventDefault();
			jQuery(this).parent().siblings(".media-pop-up__item__box__view").addClass("show");
		});




	}

	if (jQuery(".icp-listing__item__content__categories").length > 0) {
		var Swiper9 = new Swiper(".icp-listing__item__content__categories", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.icp-listing__item__content__categories .swiper-button-next',
				prevEl: '.icp-listing__item__content__categories .swiper-button-prev',
			},
		});


	}

	if (jQuery(".resources-listing__top__filter__swiper").length > 0) {
		var Swiper10 = new Swiper(".resources-listing__top__filter__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.resources-listing__top__filter__swiper .swiper-button-next',
				prevEl: '.resources-listing__top__filter__swiper .swiper-button-prev',
			},
		});
	}




}

function resize_block() {
	if (jQuery(".recommended-links__swiper").length > 0) {
		//if (jQuery(window).width() <= 768) {
		var index_c = jQuery(".recommended-links .recommended-links__swiper .swiper-slide a.active").parents(".swiper-slide").index();
		var Swiper1 = new Swiper(".recommended-links__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			navigation: {
				nextEl: '.recommended-links__swiper .swiper-button-next',
				prevEl: '.recommended-links__swiper .swiper-button-prev',
			},
		});
		Swiper1.slideTo(index_c);
		//}
	}
}

function video() {
	jQuery('.video-link.mp4').click(function (event) {

		event.preventDefault();
		jQuery(document).bind('mousewheel DOMMouseScroll', function (event) {
			event.preventDefault();
		});
		jQuery(document).bind('touchmove', function (event) {
			event.preventDefault();
		});
		var video_url = jQuery(this).find('.data-video').html();
		jQuery('.media-pop-up').find('.media-pop-up__item__box__video').append('<video   src="' + video_url + '" ></video>');
		jQuery('.media-pop-up .media-pop-up__item__box__video').fadeIn(3);
		jQuery('.media-pop-up').fadeIn(300);
		//video_hls();
	});

	jQuery('.video-link.file').click(function (event) {
		event.preventDefault();
		jQuery(document).bind('mousewheel DOMMouseScroll', function (event) {
			event.preventDefault();
		});
		jQuery(document).bind('touchmove', function (event) {
			event.preventDefault();
		});
		var video_url = jQuery(this).find('.data-video').html();
		jQuery('.media-pop-up').find('.media-pop-up__item__box__video').append('<video   src="' + video_url + '" ></video>');
		jQuery('.media-pop-up .media-pop-up__item__box__video').fadeIn(3);
		jQuery('.media-pop-up').fadeIn(300);
	});



	jQuery('.video-link.embed').click(function (event) {
		event.preventDefault();
		jQuery(document).bind('mousewheel DOMMouseScroll', function (event) {
			event.preventDefault();
		});
		jQuery(document).bind('touchmove', function (event) {
			event.preventDefault();
		});
		jQuery('.media-pop-up .media-pop-up__item__box__video').fadeIn(3);
		jQuery('.media-pop-up').fadeIn(300);
		var html = jQuery(this).find('.data-video').html();

		jQuery('.media-pop-up').find('.play-iframe-video').html(html);
	});
	jQuery('.media-pop-up .close').click(function () {
		jQuery(document).unbind('mousewheel DOMMouseScroll');
		jQuery(document).unbind('touchmove');
		jQuery('.media-pop-up').fadeOut(300);
		setTimeout(function () {
			jQuery('.media-pop-up').find('.media-pop-up__item__box__video').html('');
		}, 300);
	});

	jQuery('.media-pop-up .video-box').click(function (event) {
		event.stopPropagation();
	});

	jQuery('.media-pop-up .media-pop-up__item__box__video').click(function (event) {
		event.stopPropagation();
		var ss = jQuery('.media-pop-up .media-pop-up__item__box__video video');

		jQuery(this).toggleClass("hide-paly-icon");
		if (jQuery(this).hasClass("hide-paly-icon")) {
			ss.trigger('play');
		} else {
			ss.trigger('pause');
		}



	});
}


var animatedSpans = {};

function numbers() {

	jQuery(".content-and-number .content-and-number__item__number__block:not(.active) h4 span").each(function () {

		var wTops = jQuery(window).scrollTop(),
			wHeights = jQuery(window).height(),
			wBottoms = wTops + wHeights;
		var this_c = jQuery(this);
		var h = jQuery(this).parents(".content-and-number").offset().top;

		var ss = wTops + wHeights - 100;

		if (ss > h) {

			var me = jQuery(this).parents(".content-and-number__item__number__block"),
				meTops = me.offset().top,
				meHeights = me.innerHeight(),
				meBottoms = meTops + meHeights,
				limitTops = wTops - meHeights,
				limitBottoms = wBottoms + meHeights;
			me.addClass("active");
			var num = parseInt(jQuery(this).html());
			jQuery(this).prop('number', 0).animateNumber({
				number: num,
			},
				2000
			);

		}

	});



}


function range_slider() {
	if (jQuery(".range-slider").length > 0) {
		var $range = $(".js-range-slider"),
			instance,
			min = 0,
			max = 2000,
			from = 0,
			to = max;
		$range.ionRangeSlider({
			skin: "round",
			type: "double",
			min: min,
			max: max,
			from: min,
			to: max,
			prefix: "$",
			postfix: "",
			prettify_enabled: false,
			thousands_separator: "",
			onChange: function (data) {
				jQuery('.min-price-range-value').prop('checked', false).val(data.from).trigger('click');
				jQuery('.max-price-range-value').prop('checked', false).val(data.to).trigger('click');
			}

		});
		instance = $range.data("ionRangeSlider");
		instance.update({
		});

	}
}
